
define('jst!conversations/_participant_add',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="image-block">\n  <div class="img icon">\n    <span class="icon-16 icon-16-user-plus-gray"></span>\n  </div>\n  <div class="bd text">\n    <%= translations.participant_add %></div>\n  </div>\n</div>\n');
 });

